import { render } from "./BillingProfileView.vue?vue&type=template&id=a683fea4"
import script from "./BillingProfileView.vue?vue&type=script&lang=js"
export * from "./BillingProfileView.vue?vue&type=script&lang=js"

import "./BillingProfileView.vue?vue&type=style&index=0&id=a683fea4&lang=css"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__